import React from 'react';
import PropTypes from 'prop-types';

//FIXME: SOF-617 requires the following imports to be moved to components/widget-components.scss
// due to lazy loading of the widget inside an iframe. Keeping this here for potential fix down the road.
// import 'components/questions/RadioQuestionSelectOption.scss';

const RadioQuestionSelectOption = ({ radioName, option, isDisabled }) => {
  const { id, text, selected } = option;

  return (
    <option id={radioName}
            name={radioName}
            className="csw-select-option csw-q-rdo-s-o"
            value={id}
            disabled={isDisabled}
            selected={selected}>{text}</option>
  );
};

RadioQuestionSelectOption.propTypes /* remove-proptypes */ = {
  radioName: PropTypes.string,
  checked: PropTypes.bool,
  option: PropTypes.object.isRequired,
  isDisabled: PropTypes.bool
};

export default RadioQuestionSelectOption;
